"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Context_1 = require("../Context");
var SelectField_1 = __importDefault(require("../Fields/SelectField"));
var options = getOptions(20);
exports.default = react_1.default.forwardRef(function CardExpYearField(props, ref) {
    var _a = props.expMonthName, expMonthName = _a === void 0 ? 'expMonth' : _a, validate = props.validate, rest = __rest(props, ["expMonthName", "validate"]);
    var form = (0, Context_1.useFormContext)();
    var validateYear = function (value) {
        setTimeout(function () {
            form.validateField(expMonthName);
        }, 50); // give some time for expMonth, before calling validation, or it won't validate expMonth
        return validate === null || validate === void 0 ? void 0 : validate(value);
    };
    return (react_1.default.createElement(SelectField_1.default, __assign({ ref: ref, name: 'expYear', label: 'Exp. Year', placeholder: 'Exp. Year', validate: validateYear, autoComplete: 'cc-exp-year', options: options }, rest)));
});
function getOptions(maxYear) {
    var currentYear = new Date().getFullYear().toString().substring(2, 4);
    var currentYearNumber = parseInt(currentYear);
    var result = [{ value: '', text: 'select', disabled: true }];
    for (var i = currentYearNumber; i < currentYearNumber + maxYear; i++) {
        result.push({ value: i.toString(), text: i.toString() });
    }
    return result;
}
